import { renderSlot as _renderSlot, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (!$props.tooltip)
        ? (_openBlock(), _createBlock($setup["SidebarMenuButtonChild"], _normalizeProps(_mergeProps({ key: 0 }, { ...$setup.delegatedProps, ..._ctx.$attrs })), {
            default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3 /* FORWARDED */
        }, 16 /* FULL_PROPS */))
        : (_openBlock(), _createBlock($setup["Tooltip"], { key: 1 }, {
            default: _withCtx(() => [
                _createVNode($setup["TooltipTrigger"], { "as-child": "" }, {
                    default: _withCtx(() => [
                        _createVNode($setup["SidebarMenuButtonChild"], _normalizeProps(_guardReactiveProps({ ...$setup.delegatedProps, ..._ctx.$attrs })), {
                            default: _withCtx(() => [
                                _renderSlot(_ctx.$slots, "default")
                            ]),
                            _: 3 /* FORWARDED */
                        }, 16 /* FULL_PROPS */)
                    ]),
                    _: 3 /* FORWARDED */
                }),
                _createVNode($setup["TooltipContent"], {
                    side: "right",
                    hidden: $setup.state !== 'collapsed' || $setup.isMobile
                }, {
                    default: _withCtx(() => [
                        (typeof $props.tooltip === 'string')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString($props.tooltip), 1 /* TEXT */)
                            ], 64 /* STABLE_FRAGMENT */))
                            : (_openBlock(), _createBlock(_resolveDynamicComponent($props.tooltip), { key: 1 }))
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["hidden"])
            ]),
            _: 3 /* FORWARDED */
        }));
}
